export default __webpack_public_path__ + "static/media/loaderGren.17c974f0.gif";